// (clewis): Make this a TSX file so we get UnoCSS linting.
export const CSS_CLASS_COLUMN_GAP = "gap-6";
export const CSS_CLASS_WIDTH_IS_REQUIRED = "w-18";
